import WithImageOverlap from './WithImageOverlap'
export default WithImageOverlap
